import styled from "@emotion/styled";
import isPropValid from '@emotion/is-prop-valid';
import { ComponentType } from 'react';
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";
import { Arrow, ArrowProps } from 'react-laag';

// React 18's stricter ForwardRefExoticComponent typing breaks emotion's overload
// resolution for styled(Arrow); a plain ComponentType cast keeps ArrowProps intact.
const TypedArrow = Arrow as ComponentType<ArrowProps>;

export const Container = styled('div', {
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'display',
})<{animate?:boolean, display?:boolean}>`
    position: absolute;
    top:100%;
    right:3%;
    opacity: ${props => props.animate?"1":"0"};
    transform: ${props => props.animate?"translateY(16px)":"translateY(-10px)"};
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    width:auto;

    ${mq(Devices.mobile)} {
        position: fixed;
        top:45px;
        width:95vw;
        transform: ${props => props.animate?"translateY(16px)":"translateY(-10px)"} ;
    }
`;

export const GridContainer = styled.div` 
    width:100%;
    height:100%;
    min-width:300px;
    background:#fff;
    border-radius:5px;
    overflow:hidden;
    box-shadow: 0 0 3px 1px rgba(0,0,0,0.2);
`;

export const Grid = styled.div` 
    width:100%;
    height:100%;
    position:relative;
    display:grid;
    grid-template-columns: 60px 1fr;
    grid-template-rows: 1fr;
    align-items:center;
`;

export const Col = styled.div`
    height:100%;
    padding:15px;
    
    display:flex;

    p{
        font-size:16px;
        text-align: left;
    }
    :nth-of-type(1){
        background:#f0711f;
    }

    svg{
        align-self:center;
        path{
            fill:#fff;
        }
    }
`;

export const StyledArrow = styled(TypedArrow)<{moveRight?:boolean}>`
    width:30px;
    position: absolute;
    left:50%;
    transform: rotate(180deg) !important;
    bottom:100%;

    path {
        fill: ${(props) => props.theme.colors.white};
    }

    ${mq(Devices.mobile)} {
        
    }
`;